import { Link, useLocation } from "react-router-dom"
import { useTranslations } from "next-intl"
import {
	Sidebar,
	SidebarHeader,
	SidebarContent,
	SidebarFooter,
	SidebarMenu,
	SidebarMenuItem,
	SidebarMenuButton,
	SidebarGroup,
	SidebarGroupLabel,
	SidebarGroupContent,
	SidebarRail,
	useSidebar,
} from "@/components/ui/sidebar"
import { FileText, Users, Send, Newspaper, Settings, Banknote, LayoutDashboard } from "lucide-react"

export function AppSidebar() {
	const { pathname } = useLocation()
	const { state, setOpenMobile, isMobile } = useSidebar()
	const t = useTranslations()

	const handleNavClick = () => {
		if (isMobile) setOpenMobile(false)
	}

	const navItems = [
		{ title: "Dashboard", url: "/dashboard", icon: LayoutDashboard },
		{ title: t("navigation.tenders"), url: "/", icon: FileText },
		{ title: t("navigation.grants"), url: "/grants", icon: Banknote },
		{ title: t("navigation.contacts"), url: "/contacts", icon: Users },
		{ title: t("navigation.outreach"), url: "/outreach", icon: Send },
		{ title: t("navigation.aiNews"), url: "/ai-news", icon: Newspaper },
		{ title: t("navigation.settings"), url: "/settings", icon: Settings },
	]

	return (
		<Sidebar collapsible="icon" variant="inset">
			<SidebarHeader>
				<SidebarMenu>
					<SidebarMenuItem>
						<SidebarMenuButton size="lg" asChild className="data-[state=open]:bg-sidebar-accent data-[state=open]:text-sidebar-accent-foreground">
							<Link to="/">
								<div className="flex items-center justify-center rounded-lg overflow-hidden">
									{state === "collapsed" ? (
										<img src="/OptimLogo.png" alt="Optim Logo" width={32} height={32} className="size-8 animate-in slide-in-from-left-4 duration-1300" />
									) : (
										<img src="/OptimGovLogo.png" alt="OptimGov Logo" width={140} height={32} className="h-8 w-auto animate-in slide-in-from-right-4 duration-1300" />
									)}
								</div>
							</Link>
						</SidebarMenuButton>
					</SidebarMenuItem>
				</SidebarMenu>
			</SidebarHeader>

			<SidebarContent>
				<SidebarGroup>
					<SidebarGroupLabel>{t("navigation.menu")}</SidebarGroupLabel>
					<SidebarGroupContent>
						<SidebarMenu>
							{navItems.map((item) => (
								<SidebarMenuItem key={item.title}>
									<SidebarMenuButton asChild isActive={pathname === item.url} tooltip={item.title}>
										<Link to={item.url} onClick={handleNavClick}>
											<item.icon className="h-4 w-4" />
											<span>{item.title}</span>
										</Link>
									</SidebarMenuButton>
								</SidebarMenuItem>
							))}
						</SidebarMenu>
					</SidebarGroupContent>
				</SidebarGroup>
			</SidebarContent>

			<SidebarFooter>
				<SidebarMenu>
					<SidebarMenuItem>
						<SidebarMenuButton size="sm" className="text-xs text-muted-foreground hover:text-foreground">
							<span className="truncate">{t("sidebar.footer")}</span>
						</SidebarMenuButton>
					</SidebarMenuItem>
				</SidebarMenu>
			</SidebarFooter>

			<SidebarRail />
		</Sidebar>
	)
}
